/* ==========================================================================
   Kleos — PDP (sections/main-product.liquid + snippets/iurop-sticky-atc.liquid)
   --------------------------------------------------------------------------
   · Galería: track con scroll-snap + thumbnails superpuestas (activa/inactivas).
   · Variantes: pills → variante real (precio, imagen, stock, url, input id).
   · Oferta/cantidad: tarjetas "Compra 1 / Compra 2" → input quantity + precios.
   · Cuenta atrás de corte de envío (Hrs/Mins/Segs hasta la hora configurada).
   · Acordeones de descripción (delegación, grid-rows en CSS), sliders con
     indicador de líneas (vídeos / reseñas).
   · Sticky ATC: scroll + getBoundingClientRect (no IO, que throttlea en 2º
     plano). Aparece SIEMPRE que el CTA principal no está en pantalla (salió
     por arriba O queda bajo el fold); se oculta con el CTA visible, cerca del
     footer y con el carrito abierto. Histéresis 48px en ambos bordes.
     El botón sticky envía el mismo formulario (lo intercepta iurop-cart.js).
   Sin dependencias. Un init por sección [data-iurop-pdp].
   ========================================================================== */
(function () {
  'use strict';

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $all(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  /* ---------- dinero (mismo contrato que iurop-cart.js) ---------- */
  function formatMoney(cents, format) {
    var f = format || '${{amount_with_comma_separator}}';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    function fmt(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands == null ? ',' : thousands;
      decimal = decimal == null ? '.' : decimal;
      if (isNaN(number) || number == null) return '0';
      number = (number / 100).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var rest = parts[1] ? decimal + parts[1] : '';
      return dollars + rest;
    }
    var match = f.match(placeholder);
    var value = '';
    switch (match ? match[1] : 'amount') {
      case 'amount': value = fmt(cents, 2); break;
      case 'amount_no_decimals': value = fmt(cents, 0); break;
      case 'amount_with_comma_separator': value = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = fmt(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': value = fmt(cents, 2, ' ', ','); break;
      default: value = fmt(cents, 2);
    }
    return f.replace(placeholder, value);
  }

  function initPDP(root) {
    if (!root || root.__iuropPdpInit) return;
    root.__iuropPdpInit = true;

    var moneyFormat = root.getAttribute('data-money-format') || '${{amount_with_comma_separator}}';
    var productJson = $('[data-iurop-product-json]', root);
    var product = null;
    try { product = productJson ? JSON.parse(productJson.textContent) : null; } catch (e) { product = null; }

    var form = $('[data-iurop-product-form]', root);
    var idInput = form ? $('input[name="id"]', form) : null;
    var qtyInput = form ? $('input[name="quantity"]', form) : null;

    var state = {
      variant: null,
      qty: qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1,
      discountPct: parseFloat(root.getAttribute('data-pack-descuento') || '20')
    };
    if (product) {
      var initialId = idInput ? parseInt(idInput.value, 10) : null;
      state.variant = product.variants.filter(function (v) { return v.id === initialId; })[0] || product.variants[0];
    }

    /* ================= Galería ================= */
    var track = $('[data-iurop-gallery-track]', root);
    var thumbs = $all('[data-iurop-thumb]', root);

    function setActiveThumb(index) {
      thumbs.forEach(function (t) {
        t.classList.toggle('is-active', parseInt(t.getAttribute('data-index'), 10) === index);
      });
    }
    function goToSlide(index, smooth) {
      if (!track) return;
      var slide = track.children[index];
      if (!slide) return;
      track.scrollTo({ left: slide.offsetLeft, behavior: smooth === false ? 'auto' : 'smooth' });
      setActiveThumb(index);
    }
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        goToSlide(parseInt(t.getAttribute('data-index'), 10));
      });
    });
    if (track) {
      var scrollTid = null;
      track.addEventListener('scroll', function () {
        if (scrollTid) clearTimeout(scrollTid);
        scrollTid = setTimeout(function () {
          var index = Math.round(track.scrollLeft / track.clientWidth);
          setActiveThumb(index);
        }, 80);
      }, { passive: true });

      /* Lightbox: click en un slide de IMAGEN del track abre la galería a
         pantalla completa (snippets/iurop-lightbox.liquid + iurop-lightbox.js).
         Delegado SOLO sobre el track: las miniaturas [data-iurop-thumb] viven
         fuera y no lo disparan. Un swipe táctil real no genera click (lo
         cancela el navegador), no hace falta lógica drag-vs-click. Los
         data-media-id superan 2^31 → se pasan como String, nunca parseInt. */
      track.addEventListener('click', function (event) {
        var slide = event.target.closest('[data-media-id]');
        if (!slide || !track.contains(slide)) return;
        if (slide.querySelector('video, iframe, model-viewer')) return;
        if (window.iuropLightbox) window.iuropLightbox.open(slide.getAttribute('data-media-id'));
      });
    }
    function goToMedia(mediaId) {
      if (!track || !mediaId) return;
      /* Media ids SIEMPRE como String (regla del guide): el caller pasa el
         id numérico del JSON de producto → String() en ambos lados. */
      var idStr = String(mediaId);
      var slides = $all('[data-media-id]', track);
      for (var i = 0; i < slides.length; i++) {
        if (String(slides[i].getAttribute('data-media-id')) === idStr) { goToSlide(i); return; }
      }
    }

    /* ================= Variantes ================= */
    var optionPills = $all('[data-iurop-option-pill]', root);

    function selectedOptions() {
      var opts = [];
      $all('[data-iurop-option-group]', root).forEach(function (group) {
        var active = $('[data-iurop-option-pill].is-selected', group);
        opts.push(active ? active.getAttribute('data-value') : null);
      });
      return opts;
    }
    function findVariant(opts) {
      if (!product) return null;
      return product.variants.filter(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      })[0] || null;
    }

    function renderPrices() {
      if (!state.variant) return;
      var price = state.variant.price;
      var compare = state.variant.compare_at_price;

      var p1 = $('[data-iurop-price-1]', root);
      var c1 = $('[data-iurop-compare-1]', root);
      if (p1) p1.textContent = formatMoney(price, moneyFormat);
      if (c1) {
        if (compare && compare > price) {
          c1.textContent = formatMoney(compare, moneyFormat);
          c1.removeAttribute('hidden');
        } else {
          c1.setAttribute('hidden', '');
        }
      }

      var packQty = 2;
      var packBase = price * packQty;
      var packFinal = Math.round(packBase * (1 - state.discountPct / 100));
      var p2 = $('[data-iurop-price-2]', root);
      var c2 = $('[data-iurop-compare-2]', root);
      if (p2) p2.textContent = formatMoney(packFinal, moneyFormat);
      if (c2) c2.textContent = formatMoney(packBase, moneyFormat);

      /* Etiqueta de envío gratis: depende del TOTAL de cada opción, así que si
         la variante cambia de precio hay que re-evaluarla. Umbral en céntimos,
         el mismo del carrito. 0 = desactivado. */
      var envioUmbral = parseInt(root.getAttribute('data-envio-umbral') || '0', 10);
      if (envioUmbral > 0) {
        var e1 = $('[data-iurop-envio-1]', root);
        var e2 = $('[data-iurop-envio-2]', root);
        if (e1) e1.hidden = price < envioUmbral;
        if (e2) e2.hidden = packFinal < envioUmbral;
      }

      /* CTA sticky: precio total según cantidad elegida */
      var total = state.qty === 2 ? packFinal : price;
      $all('[data-iurop-sticky-total]').forEach(function (el) {
        el.textContent = formatMoney(total, moneyFormat);
      });
      $all('[data-iurop-sticky-price]').forEach(function (el) {
        el.textContent = formatMoney(price, moneyFormat);
      });
    }

    function renderStock() {
      var badge = $('[data-iurop-stock]', root);
      if (!badge || !state.variant) return;
      var threshold = parseInt(root.getAttribute('data-stock-umbral') || '10', 10);
      var qty = state.variant.inventory_quantity;
      var managed = state.variant.inventory_management != null && qty != null;
      badge.classList.remove('is-low', 'is-in', 'is-out');
      var label = $('[data-iurop-stock-label]', badge) || badge;
      if (!state.variant.available) {
        badge.classList.add('is-out');
        label.textContent = 'Sin stock';
      } else if (managed && qty > 0 && qty <= threshold) {
        badge.classList.add('is-low');
        label.textContent = 'Casi sin stock';
      } else {
        badge.classList.add('is-in');
        label.textContent = 'En stock';
      }
    }

    function renderCtaState() {
      var available = state.variant ? state.variant.available : false;
      $all('[data-iurop-atc]').forEach(function (btn) {
        btn.disabled = !available;
        var span = $('[data-iurop-atc-text]', btn);
        if (span) span.textContent = available ? btn.getAttribute('data-text-add') : 'Sin stock';
      });
    }

    function onVariantChange() {
      if (!state.variant) return;
      if (idInput) idInput.value = state.variant.id;
      if (state.variant.featured_media && state.variant.featured_media.id) {
        goToMedia(state.variant.featured_media.id);
      }
      renderPrices();
      renderStock();
      renderCtaState();
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', state.variant.id);
        window.history.replaceState({}, '', url.toString());
      } catch (e) { /* noop */ }
    }

    optionPills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        var group = pill.closest('[data-iurop-option-group]');
        $all('[data-iurop-option-pill]', group).forEach(function (p) { p.classList.remove('is-selected'); });
        pill.classList.add('is-selected');
        var v = findVariant(selectedOptions());
        if (v) { state.variant = v; onVariantChange(); }
      });
    });

    /* ================= Oferta / cantidad ================= */
    var offerCards = $all('[data-iurop-offer]', root);
    offerCards.forEach(function (card) {
      card.addEventListener('click', function () {
        offerCards.forEach(function (c) {
          c.classList.remove('is-selected');
          c.setAttribute('aria-pressed', 'false');
        });
        card.classList.add('is-selected');
        card.setAttribute('aria-pressed', 'true');
        state.qty = parseInt(card.getAttribute('data-qty'), 10) || 1;
        if (qtyInput) qtyInput.value = state.qty;
        renderPrices();
      });
    });

    /* ================= Cuenta atrás de envío =================
       La hora de corte es la de la TIENDA (data-tz, default Argentina), no la
       del visitante: mismo patrón nowInTz que iurop-personalizar.js. */
    var timer = $('[data-iurop-countdown]', root);
    if (timer) {
      var cutoff = parseInt(timer.getAttribute('data-hora-corte') || '15', 10);
      var cdTz = timer.getAttribute('data-tz') || 'America/Argentina/Buenos_Aires';
      var hEl = $('[data-iurop-cd-h]', timer);
      var mEl = $('[data-iurop-cd-m]', timer);
      var sEl = $('[data-iurop-cd-s]', timer);
      var pad = function (n) { return n < 10 ? '0' + n : String(n); };
      var nowInTz = function () {
        try {
          return new Date(new Date().toLocaleString('en-US', { timeZone: cdTz }));
        } catch (e) { return new Date(); }
      };
      var tick = function () {
        var now = nowInTz();
        var end = new Date(now.getFullYear(), now.getMonth(), now.getDate(), cutoff, 0, 0);
        if (end <= now) end.setDate(end.getDate() + 1);
        var diff = Math.max(0, Math.floor((end - now) / 1000));
        if (hEl) hEl.textContent = pad(Math.floor(diff / 3600));
        if (mEl) mEl.textContent = pad(Math.floor((diff % 3600) / 60));
        if (sEl) sEl.textContent = pad(diff % 60);
      };
      tick();
      setInterval(tick, 1000);
    }

    /* ================= Sliders con indicador de líneas =================
       Los dashes son BOTONES: click → scroll al slide correspondiente. */
    $all('[data-iurop-slider]', root).forEach(function (wrap) {
      var row = $('[data-iurop-slider-track]', wrap);
      var dashes = $all('[data-iurop-slider-dash]', wrap);
      if (!row || !dashes.length) return;
      var sync = function () {
        var max = row.scrollWidth - row.clientWidth;
        var ratio = max > 0 ? row.scrollLeft / max : 0;
        var active = Math.round(ratio * (dashes.length - 1));
        dashes.forEach(function (d, i) { d.classList.toggle('is-active', i === active); });
      };
      row.addEventListener('scroll', sync, { passive: true });
      dashes.forEach(function (d, i) {
        d.addEventListener('click', function () {
          var slides = row.children;
          var target = slides[Math.min(i, slides.length - 1)];
          if (!target) return;
          var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          row.scrollTo({
            left: target.offsetLeft - row.offsetLeft,
            behavior: (reduced || document.hidden) ? 'auto' : 'smooth'
          });
        });
      });
      sync();
    });

    /* ================= Rating de cabecera → scroll a reseñas =================
       El bloque de valoración (role=button) lleva a la sección de reseñas de
       la PDP (sections/iurop-pdp-resenas). Si la plantilla no la incluye, el
       click no hace nada. */
    $all('[data-iurop-rating-link]', root).forEach(function (link) {
      var goResenas = function () {
        var target = document.querySelector('[data-iurop-resenas]');
        if (!target) return;
        var sec = target.closest('.shopify-section') || target;
        var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        sec.scrollIntoView({ behavior: (reduced || document.hidden) ? 'auto' : 'smooth', block: 'start' });
      };
      link.addEventListener('click', goResenas);
      link.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); goResenas(); }
      });
    });

    /* ================= Vídeos "Así lo recibís" ================= */
    $all('[data-iurop-video]', root).forEach(function (card) {
      card.addEventListener('click', function () {
        var src = card.getAttribute('data-video-src');
        if (!src || card.classList.contains('is-playing')) return;
        var video = document.createElement('video');
        video.src = src;
        video.controls = true;
        video.autoplay = true;
        video.playsInline = true;
        video.className = 'iurop-pdp__video-player';
        card.appendChild(video);
        card.classList.add('is-playing');
      });
    });

    /* ================= "Leer más" reseña ================= */
    $all('[data-iurop-leer-mas]', root).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var card = btn.closest('[data-iurop-review-card]');
        if (!card) return;
        var expanded = card.classList.toggle('is-expanded');
        btn.textContent = expanded ? 'Leer menos' : 'Leer más';
      });
    });

    /* ================= Sticky ATC =================
       Cuándo aparece/desaparece (optimizado, no IntersectionObserver):
       - APARECE SIEMPRE que el CTA principal no está en pantalla: se fue por
         ARRIBA (rect.bottom <= 0) O queda por DEBAJO del fold
         (rect.top >= innerHeight) — incluida la carga inicial en móvil con el
         CTA bajo el fold (QA 5.4).
       - DESAPARECE cuando el CTA vuelve a ser visible, al acercarse al
         footer (para no taparlo) y mientras el carrito lateral está abierto.
       - Histéresis de 48px en AMBOS bordes para que no parpadee.
       - Listener scroll pasivo SÍNCRONO (una lectura de rect, barato) — sin
         rAF, que se estrangula en 2º plano y congelaría el estado. */
    var stickyBar = document.getElementById('IuropStickyAtc');
    var mainCta = $('[data-iurop-main-cta]', root);
    if (stickyBar && mainCta) {
      var stFooter = document.querySelector('.iurop-footer');
      var ST_HYST = 48;        // histéresis anti-parpadeo
      var ST_FOOTER_GAP = 16;  // margen antes del footer para ocultar
      var stShown = false;

      var updateSticky = function () {
        var ctaRect = mainCta.getBoundingClientRect();
        var vh = window.innerHeight;
        // CTA fuera de pantalla (arriba u abajo); histéresis según el estado:
        // ya visible → solo se oculta cuando el CTA asoma ≥48px en el viewport.
        var ctaOff = stShown
          ? (ctaRect.bottom <= ST_HYST || ctaRect.top >= vh - ST_HYST)
          : (ctaRect.bottom <= 0 || ctaRect.top >= vh);
        var nearFooter = false;
        if (stFooter) {
          nearFooter = stFooter.getBoundingClientRect().top <= (vh - ST_FOOTER_GAP);
        }
        var cartOpen = document.documentElement.classList.contains('iurop-cd-locked');
        var show = ctaOff && !nearFooter && !cartOpen;
        if (show !== stShown) {
          stShown = show;
          stickyBar.classList.toggle('is-visible', show);
          document.body.classList.toggle('iurop-sticky-atc-visible', show);
        }
      };
      /* Síncrono en el propio evento (los scroll pasivos ya vienen ~1/frame y
         una sola lectura de rect es barata). Evita depender de rAF, que se
         estrangula/pausa en 2º plano y dejaría el estado congelado. */
      window.addEventListener('scroll', updateSticky, { passive: true });
      window.addEventListener('resize', updateSticky, { passive: true });
      /* Re-sincronizar en eventos que no disparan scroll (carrito, volver a
         la pestaña — rAF se estrangula en 2º plano) leyendo el estado directo. */
      document.addEventListener('cart:updated', updateSticky);
      document.addEventListener('iurop:cart:toggle', updateSticky);
      document.addEventListener('visibilitychange', updateSticky);
      window.addEventListener('pageshow', updateSticky);
      updateSticky();
    }
    $all('[data-iurop-sticky-submit]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!form) return;
        if (typeof form.requestSubmit === 'function') form.requestSubmit();
        else form.submit();
      });
    });

    /* pintado inicial */
    renderPrices();
    renderStock();
    renderCtaState();
  }

  /* ================= Acordeones de descripción =================
     Delegación en document: sobrevive a recargas de sección en el editor. */
  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-iurop-acc-btn]');
    if (!btn) return;
    var item = btn.closest('[data-iurop-acc]');
    if (!item) return;
    var open = item.classList.toggle('is-open');
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  function boot() {
    $all('[data-iurop-pdp]').forEach(initPDP);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
